// src/pages/Home.js
import React from "react";
import { Link } from "react-router-dom";
import { FiTarget, FiFeather, FiShield } from "react-icons/fi";

export default function Home() {
  return (
    <main className="home-light">
      {/* HERO */}
<section className="home-hero-light">
  <div className="home-hero-grid">
    <div className="home-hero-image">
      <img
        src="/images/accueil.jpg"
        alt="Photographie culinaire en cuisine gastronomique – Maxime H"
      />
    </div>

          {/* Texte à droite */}
          <div className="home-hero-content">
             <h1 className="home-title-light">
              Photographe culinaire pour restaurants, traiteurs, hôtels, artisans et marques 
              en France, Luxembourg &amp; Belgique
            </h1>

            <p className="home-intro-light">
              Je suis Maxime, photographe culinaire. J’accompagne les chefs, restaurants, hôtels, traiteurs, 
              artisans et maisons d’exception dans la création d’images gastronomiques haut de gamme. 
              Chaque plat, chaque geste, chaque portrait et chaque lieu sont photographiés pour révéler votre univers, 
              votre cuisine et l’émotion que vous transmettez à vos clients.
              Habitué à travailler en service, en lumière naturelle ou en lumière maîtrisée, je construis avec vous 
              une direction visuelle claire pour vos menus, sites internet, réseaux sociaux, supports imprimés et 
              dossiers presse. Mon objectif : créer des images cohérentes, fortes et utiles à votre communication, 
              reflétant l’identité et l’excellence de votre établissement.
              Basé entre Bruxelles et Tomblaine dans le Grand Est, je me déplace partout en France, au Luxembourg et 
              en Belgique pour réaliser des shootings culinaires, des portraits de chefs, des reportages en cuisine et des prises de vues 
              d’ambiance là où la gastronomie s’exprime.
            </p>

            <p className="home-intro-light">
              Habitué à travailler en service, en lumière naturelle ou en
              lumière maîtrisée, je construis avec vous une direction visuelle
              claire pour vos <strong>menus</strong>, <strong>sites internet</strong>,{" "}
              <strong>réseaux sociaux</strong>, supports <strong>print</strong> ou
              dossiers presse. Mon objectif&nbsp;: des images utiles, belles et
              cohérentes avec l’identité de votre établissement.
            </p>

            <div className="home-cta-row-light">
              <Link to="/galerie" className="btn-ghost-light">
                Voir la galerie
              </Link>
              <Link to="/contact" className="btn-ghost-light">
                Demander un devis en 24h
              </Link>
            </div>

            {/* Cartes avec pictos */}
            <div className="home-cards-row">
              <div className="home-card-light">
                <div className="home-card-icon">
                  <FiTarget />
                </div>
                <h3>Précision</h3>
                <p>
                  Contrôle de la lumière, des couleurs et des cadrages pour des
                  visuels cohérents et fidèles à votre cuisine.
                </p>
              </div>

              <div className="home-card-light">
                <div className="home-card-icon">
                  <FiFeather />
                </div>
                <h3>Créativité gastronomique</h3>
                <p>
                  Une esthétique au service de votre objectif&nbsp;: valoriser
                  votre carte, attirer, donner envie, convaincre.
                </p>
              </div>

              <div className="home-card-light">
                <div className="home-card-icon">
                  <FiShield />
                </div>
                <h3>Confiance</h3>
                <p>
                  Repérage, préparation, respect des délais et livrables prêts à
                  l’emploi pour le web, le print et la presse.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION : À QUI JE M’ADRESSE */}
      <section className="home-section-light centered">
        <div className="home-section-inner-light">
          <h2>Une photographie culinaire dédiée aux professionnels de la gastronomie</h2>
          <p>
            Photographe culinaire spécialisé en gastronomie, je crée des images professionnelles destinées aux restaurants, chefs, hôtels, traiteurs, artisans et producteurs. 
            J’interviens en France, au Luxembourg et en Belgique pour réaliser des photos de plats, portraits de chefs et brigades, reportages en cuisine, prises de vues de salles, ambiances et expériences culinaires.
            Chaque image est pensée pour valoriser votre établissement : lumière maîtrisée, stylisme culinaire, textures, dressages, atmosphères et gestes techniques. Mon approche vise à renforcer votre identité visuelle, optimiser votre communication et créer des visuels cohérents pour vos menus, cartes, réseaux sociaux, sites internet, supports print, presse et guides gastronomiques.
          </p>

          <div className="home-grid-light">
            <div>
              <h3>Chefs &amp; restaurants</h3>
              <p>
                Plats signatures, menus dégustation, cartes saisonnières, dressages techniques, 
                mises en place, gestes culinaires et service en salle.
              </p>
            </div>
            <div>
              <h3>Hôtels &amp; maisons d’exception</h3>
              <p>
                Restaurants d’hôtels, room service, bars à cocktails, expériences culinaires, 
                art de la table, atmosphères premium et espaces raffinés.
              </p>
            </div>
            <div>
              <h3>Traiteurs &amp; événements</h3>
              <p>
                Cocktails, buffets, banquets, événements corporate ou privés, 
                réceptions sur-mesure, valorisation des plats et des équipes.
              </p>
            </div>
            <div>
              <h3>Artisans &amp; producteurs</h3>
              <p>
                Produits bruts, gestes, ateliers, portraits d’artisans, terroirs, savoir-faire 
                et mise en valeur de votre univers de production.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION : CTA FINAL */}
      <section className="home-section-light home-section-center-light">
        <div className="home-section-inner-light">
          <h2>Sublimez votre univers culinaire</h2>
          <p className="home-text-narrow">
            Vous souhaitez renouveler les visuels de votre carte, préparer une
            ouverture, renforcer l’image de votre maison gastronomique ou créer
            une banque d’images cohérente&nbsp;? Parlons de votre projet et
            construisons ensemble un shooting sur-mesure.
          </p>

          <div className="home-cta-row-light home-cta-center">
            <Link to="/contact" className="btn-primary-light">
              Demander un devis en 24h
            </Link>
            <Link to="/galerie" className="btn-ghost-light">
              Voir la galerie
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}